import cache from "./cachedState";

let state = {
  token: null,
  user: {
    name: null,
    email: null,
    photoUrl: null,
    auth: {},
    meta: {},
    id: null,
    subscription: {
      status: 'inactive'
    }
  },
  login_at: null,
  notice_shown: false
};

const cachedStateId = "vuex-user";
var cachedState = cache.load(cachedStateId);
if (cachedState) {
  if(!state.user.subscription) {
    state.user.subscription = {
      status: 'inactive'
    }
  }
  state = JSON.parse(cachedState);
}

let actions = {};

let getters = {
  isAuthenticated(state) {
    return (state.user && state.user.email) != null;
  }
};

let mutations = {
  setUser(state, user) {
    if (!user) {
      state.user.name = null;
      state.user.email = null;
      state.user.photoUrl = null;
      state.user.auth = null;
      state.user.meta = null;
      state.token = null;
      state.user['login_at'] = null;
      state.user.subscription = {
        status: 'inactive'
      };
      state.user.referral_code = null;
      state.user.annotations = null;
      cache.clear(cachedStateId);
      cache.save(cachedStateId, JSON.stringify(state));
      return;
    }
    // state.user.raw = user
    state.user.name = user.name;
    state.user.email = user.email;
    state.user.photoUrl = user.auth ? user.auth.picture : null;
    state.user.meta = user.meta;
    state.user.auth = user.auth;
    state.user.id = user.id;
    state.user['login_at'] = user['login_at'];
    state.user.subscription = user.subscription;
    state.user.annotations = user.annotations;

    if(user.referral_code) {
      state.user.referral_code = user.referral_code;
    }

    cache.save(cachedStateId, JSON.stringify(state));
  },

  setSubscription(state, subscription) {
    state.user.subscription = subscription;
    cache.save(cachedStateId, JSON.stringify(state));
  },

  setNoticeShown(state, shown) {
    state.notice_shown = shown;
    cache.save(cachedStateId, JSON.stringify(state));
  },

  setToken(state, token) {
    state.token = token;
    cache.save(cachedStateId, JSON.stringify(state));
  },

  setPremium(state, value) {
    state.user.subscription.status = value;
  }
};

export default {
  name: "user",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
